import { Box, CircularProgress } from "@mui/material";
import React from "react";

export const LoadingAnimation = () => {
  return (
    <Box
      style={{
        height: "50vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
};
